import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link } from '@resy/ui-kitchen';
import { scrollToSection, handleMktAnalytics } from '../../AmexMarketingUtils/AmexUtils';
import { CTA_EVENT_NAME } from '../../AmexMarketingUtils/constants';
import './AmexSecurityCenterHeader.scss';

const AmexSecurityCenterHeader = (
  {
    headerConfig: {
      links,
    },
    matchMedia,
    displayMenuItems,
    activeSection,
    eventAnalytics,
  }
) => {
  const [isScrolled, setIsScrolled] = useState(false);

  const onScroll = () => {
    if (window.scrollY <= 580) {
      setIsScrolled(false);
    } else {
      setIsScrolled(true);
    }
  };

  useEffect(() => {
    if (matchMedia.md) {
      window.addEventListener('scroll', onScroll);
    }
    return () => window.removeEventListener('scroll', onScroll);
  }, [matchMedia]);

  const scrollToActiveLink = () => {
    const activeTarget = document.getElementsByClassName('AmexSecurityCenterHeader__item link-active')[0];

    setTimeout(() => {
      activeTarget?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }, 100);
  };

  useEffect(() => {
    if (!matchMedia.lg) {
      window.addEventListener('scroll', scrollToActiveLink);
    }
    return () => window.removeEventListener('scroll', scrollToActiveLink);
  }, [activeSection]);

  const displayCTA = (cta) => {
    const { label, url, name } = cta;
    if (!label || !url || !name || displayMenuItems[name] === false) return null;
    const extraPrams = {
      action_name: 'Menu - Click',
      item_name: label,
    };
    return (
      <li
        key={label}
        className={cx('AmexSecurityCenterHeader__item', {
          'link-active': `#${activeSection}` === `${url}_section`,
        })}
      >
        <Link
          href={window?.location?.href?.split('#')[0] + url}
          className={cx('AmexSecurityCenterHeader__link', {
            activeLink: `#${activeSection}` === `${url}_section`,
          })}
          onContextMenu={() => handleMktAnalytics(eventAnalytics, CTA_EVENT_NAME, extraPrams)}
          onClick={() => {
            scrollToSection(url, 210);
            handleMktAnalytics(eventAnalytics, CTA_EVENT_NAME, extraPrams);
          }}
        >
          {label}
        </Link>
      </li>
    );
  };
  return (
    <section
      className={cx('AmexSecurityCenterHeader', {
        scrolled: isScrolled,
      })}
    >
      <nav
        className="AmexSecurityCenterHeader__nav"
        aria-label="Page navigation"
      >
        <div className="container">
          <div className="AmexSecurityCenterHeader__wrapper">
            <ul>
              {links?.length > 0 && links.map((link) => displayCTA(link))}
            </ul>
          </div>
        </div>
      </nav>
    </section>
  );
};

AmexSecurityCenterHeader.propTypes = {
  headerConfig: PropTypes.shape({
    links: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  displayMenuItems: PropTypes.shape({}).isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  activeSection: PropTypes.string.isRequired,
  eventAnalytics: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const {
    amexGDAEvents,
  } = state;

  return {
    activeSection: amexGDAEvents?.activeSection,
  };
};

export { AmexSecurityCenterHeader as ComponentUnderTest, mapStateToProps };
export default connect(mapStateToProps)(AmexSecurityCenterHeader);
